;(function () {
  'use strict'

  angular.module('contrast.toast').factory('logger', loggerFactory)

  function loggerFactory(toastr) {
    'ngInject'

    var service = {
      remove: remove,
      clear: clear,
      log: log,
      logWarning: logWarning,
      logSuccess: logSuccess,
      logError: logError
    }

    function remove(toast) {
      return toast ? toastr.remove(toast.toastId) : {}
    }

    function clear() {
      return toastr.clear()
    }

    function log(message, options) {
      return toastr.info(message, options || {})
    }

    function logWarning(message, options) {
      return toastr.warning(message, options || {})
    }

    function logSuccess(message, options) {
      return toastr.success(message, options || {})
    }

    function logError(message, options) {
      return toastr.error(message, options || {})
    }

    return service
  }
})()
